import { apiGet, apiPost } from "./apiClient";
import { publishSourcingChange } from "../suppliers/supplierRecommendationsModel";

// Reused by both CustomerEditDrawer (customer-drawer) and
// VehicleBrandModelModal (drafts) — same brand/model lookup+add flow.
export function fetchVehicleBrands() {
  return apiPost("/whatsapp/get_makes_v2", { name: "" })
    .then(res => res.data?.success ? res.data.data.map(item => ({ value: item.id, label: item.name })) : []);
}

export function fetchVehicleModels(brandId) {
  return apiPost("/whatsapp/get_models_v2", { make: brandId })
    .then(res => res.data?.success ? res.data.data.map(item => ({ value: item.id, label: item.model })) : []);
}

// Callers branch on res.data.success/res.data.message to remap the
// returned option list or show an error, so the raw payload is returned.
export function addVehicleBrand(name) {
  return apiPost("/whatsapp/add_makes_v2", { name }).then(res => res.data);
}

export function addVehicleModel(brandId, model) {
  return apiPost("/whatsapp/add_model_v2", { make: brandId, model }).then(res => res.data);
}

export function fetchVehiclesByCustomer(customerId) {
  return apiGet(`/customer-vehicles-v1/vehicles?customer_id=${customerId}`)
    .then(res => Array.isArray(res.data?.data) ? res.data.data : [])
    .catch(() => []);
}

export function saveVehicle(payload, { isEdit }) {
  return apiPost(isEdit ? "/customer_vehicles/update" : "/customer_vehicles/create", payload).then(res => { if (res.data?.success) publishSourcingChange(); return res.data; });
}

export function deleteVehicle(id) {
  return apiPost("/customer_vehicles/delete", { id }).then(res => { if (res.data?.success) publishSourcingChange(); return res.data; });
}
